// The navigate-to highlight (.highlight, defined in styles/_common.scss) owns its length in
// CSS. PanelState adds the class and needs the same number to take it off again, so it reads
// the running animation's duration back from the element. The constant is the fallback for
// environments without layout (unit tests) and for the global reduced-motion rule, which
// collapses every animation to 0.01ms: there the class holds a static wash for the full beat.
export const ANSWER_HIGHLIGHT_DURATION_MS = 2300

// Timer jitter must never cut the last frame short. The animation has already settled back
// into the surface's own styles by then, so a slightly late removal is invisible.
export const ANSWER_HIGHLIGHT_REMOVE_SLACK_MS = 40

// Anything shorter is not a real duration but the reduced-motion collapse.
const COLLAPSED_ANIMATION_MS = 100

export function parseCssTimeMs(value: string): number {
    const trimmed = value.trim()
    if (!trimmed) return 0
    const number = parseFloat(trimmed)
    if (!Number.isFinite(number)) return 0
    return trimmed.endsWith('ms') ? number : number * 1000
}

export function readAnimationDurationMs(element: Element | null | undefined): number {
    const view = element?.ownerDocument?.defaultView
    if (!element || typeof view?.getComputedStyle !== 'function') return 0
    const durations = view.getComputedStyle(element).animationDuration || ''
    return durations.split(',').reduce((max, part) => Math.max(max, parseCssTimeMs(part)), 0)
}

export function getAnswerHighlightHoldMs(element: Element | null | undefined): number {
    const animatedMs = readAnimationDurationMs(element)
    const holdMs = animatedMs >= COLLAPSED_ANIMATION_MS ? animatedMs : ANSWER_HIGHLIGHT_DURATION_MS
    return holdMs + ANSWER_HIGHLIGHT_REMOVE_SLACK_MS
}
